import {registerTreasury} from '@/commons/popupRegister/treasuryRegister.js';
import {registerBudgetPlan} from '@/commons/popupRegister/budgetPlanRegister.js';
import {registerQuickSearch} from '@/commons/popupRegister/quickSearchRegister.js';
import {registerCA} from '@/commons/popupRegister/caRegister';
import {registerE} from '@/commons/popupRegister/eRegister';
import {registerDictionary} from '@/commons/popupRegister/dictionaryRegister.js';
import {registerDeposits} from '@/commons/popupRegister/depositsRegister.js';
import {registerETreasury} from '@/commons/popupRegister/eTreasuryRegister.js';
import {registerReport} from '@/commons/popupRegister/reportRegister.js';
import {registerFAVoucher} from '@/commons/popupRegister/faVoucherRegister.js';
import {registerOutward} from '@/commons/popupRegister/outwardRegister.js';
import {registerSummary} from '@/commons/popupRegister/summaryRegister.js';
import {registerTools} from '@/commons/popupRegister/toolsRegister.js';
import {registerSystem} from '@/commons/popupRegister/systemRegister.js';
import {registerSetup} from '@/commons/popupRegister/setupRegister';
import {registerSalary} from '@/commons/popupRegister/salaryRegister.js';
import {registerUtility} from '@/commons/popupRegister/utilityRegister.js';
import {registerCommonPopup} from '@/commons/popupRegister/commonPopupRegister.js';
import {registerFr} from '@/commons/popupRegister/fRRegister.js';
import {invoiceRegister} from './popupRegister/invoiceRegister';
import {registerDashboardPopup} from './popupRegister/dashboardPopupRegister';
import {examinationResultRegister} from '@/commons/popupRegister/examinationResultRegister';
import {tourPopupRegister} from '@/commons/popupRegister/tourPopupRegister';
import {registerSettlementInstruction} from '@/commons/popupRegister/settlementInstructionRegister';

export function register(app) {
  registerTreasury(app);
  registerBudgetPlan(app);
  registerCA(app);
  registerE(app);
  registerQuickSearch(app);
  registerETreasury(app); // Khai báo các poup cho kho bạc điện tử
  registerDictionary(app);
  registerDeposits(app);
  registerReport(app); // Khai báo các popup liên quan đến báo cáo
  registerFAVoucher(app);
  registerOutward(app);
  registerSummary(app);
  registerTools(app);
  registerSystem(app);
  registerSetup(app);
  registerUtility(app);
  registerSalary(app);
  registerCommonPopup(app);
  registerFr(app);
  invoiceRegister(app);
  registerDashboardPopup(app);
  examinationResultRegister(app);
  tourPopupRegister(app);
  registerSettlementInstruction(app);
}
